import React, { useEffect, useState } from 'react'
import { convertCurrencies, fetchCurrencies } from '../../api/api_currency'
import CurrencySelector from './CurrencySelector'

function CurrencyConverter() {

    const [fromCurrency, setFromCurrency] = useState()
    const [toCurrency, setToCurrency] = useState()
    const [amount, setAmount] = useState(0)
    const [calculatedRate, setCalculatedRate] = useState(0)
    const [currencies, setCurrencies] = useState([])
    const [currenciesFormattedArray, setCurrenciesFormattedArray] = useState([])

    const [switchMessage, setSwitchMessage] = useState(false)
    const [currencySwitchedTo, setCurrencySwitchedTo] = useState(null)
    const [currencySwitchedFrom, setCurrencySwitchedFrom] = useState(null)

    useEffect(() => {
        async function fetchData() {
            const response = await fetchCurrencies();
            if (response.data.currencies) {
                const currenciesArray = Object.keys(response.data.currencies).map((key) => [String(key), response.data.currencies[key]]);
                const newArray = currenciesArray.map(currency => {
                    return {
                        ticker: currency[0],
                        currencyName: currency[1]
                    }
                })
                console.log(newArray, "NEW ARRAY")
                setCurrenciesFormattedArray(newArray)
                setCurrencies(currenciesArray)
            }
            //console.log(response.data, "Response useEffect currency selector")
        }
        fetchData()

    }, [])

    async function calculateCurrency() {
        if (fromCurrency && toCurrency && amount) {
            try {
                const calculatedSum = await convertCurrencies(fromCurrency, toCurrency, amount)
                console.log(calculatedSum)
                console.log(calculatedSum.data.rates[toCurrency].rate_for_amount)
                setCalculatedRate(calculatedSum?.data?.rates[toCurrency]?.rate_for_amount || 0)
            } catch (error) {
                console.log(error)
            }
        }

    }

    function findCurrencyByTicker(ticker) {
        const currency = currenciesFormattedArray.filter(currency => {
            return currency.ticker === ticker
        })
        console.log(currency[0])
        return currency
    }

    function switchCurrencies() {
        let toCurrencySwitch = toCurrency
        let fromCurrencySwitch = fromCurrency

        const currencyFrom = findCurrencyByTicker(fromCurrency)
        const currencyTo = findCurrencyByTicker(toCurrency)
        setCurrencySwitchedFrom(currencyFrom)
        setCurrencySwitchedTo(currencyTo)

        console.log(currencyFrom, "from")
        console.log(currencyTo, "to")

        setFromCurrency(toCurrencySwitch)
        setToCurrency(fromCurrencySwitch)
        setSwitchMessage(true)
        setTimeout(() => {
            setSwitchMessage(false)
        }, 500)
    }

    return (
        <div>
            CurrencyConverter
            <div className="row my-4">
   
                <div className="col-12">
                    {calculatedRate > 0 && (<h2>Beløp: {calculatedRate}</h2>)}
                </div>   

                <div className="col-lg-6">
                    {currenciesFormattedArray && <CurrencySelector currency={fromCurrency} setCurrency={setFromCurrency} currencies={currenciesFormattedArray} currencySwitched={currencySwitchedFrom} />}
                </div>
                <div className="col-lg-6">
                    {currenciesFormattedArray && <CurrencySelector currency={toCurrency} setCurrency={setToCurrency} currencies={currenciesFormattedArray} currencySwitched={currencySwitchedTo} />}                    
                </div>
                {fromCurrency && toCurrency && (
                    <div className="col-12">
                        {switchMessage && (
                            <div className="alert alert-success">Switched currencies</div>
                        )}
                        <button className="btn btn-info" onClick={switchCurrencies}><i className="fas fa-exchange-alt"></i> Switch</button>
                    </div>
                )}
                <div className="col-lg-12">
                    <label>Beløp</label>
                    <input type="number" value={amount} onChange={e => setAmount(e.target.value)} className="form-control" />
                </div>
                <div className="col-12 mt-2">
                    <button className="btn btn-success btn-block" onClick={calculateCurrency}>Kalkuler</button>
                </div>
            </div>
        </div>
    )
}
export default CurrencyConverter